export default __webpack_public_path__ + "static/media/search_contrata.4699bf52.png";